module.exports = __webpack_public_path__ + "img/nasa.6d6bd393.svg";